import Title from "../components/TheTitle.vue";
import CouponInfo from "../components/CouponInfo.vue";
import ModalQrCode from "../components/QRModal.vue";
import { searchCouponBulkOperationHistory, searchCouponHistory, searchUser, getCouponDetail, } from "../api";
import { FormatDate } from "../utils/formatDate";
import { Authorize } from "../utils/authorize";
export default {
    name: "CouponGrantResult",
    data() {
        return {
            tableInfo: [],
            pageSize: 100,
            infoPage: 1,
            couponCode: "",
            couponBulkOperationHistoryId: "",
            sCResult: [],
            sUResult: [],
            sCBResult: {},
            show: false,
            type: "coupon",
            name: "",
            value: "",
        };
    },
    components: {
        Title,
        CouponInfo,
        ModalQrCode,
    },
    computed: {
        infoTotalPages() {
            return Math.max(1, Math.ceil(this.tableInfo.length / this.pageSize));
        },
        pagedInfo() {
            const start = (this.infoPage - 1) * this.pageSize;
            return this.tableInfo.slice(start, start + this.pageSize);
        },
    },
    watch: {
        // データが変更されたらページを先頭に戻す
        info() {
            this.infoPage = 1;
        },
    },
    async created() {
        const route = this.$route;
        const idFromParams = (route &&
            route.params &&
            route.params.couponBulkOperationHistoryId) ||
            "";
        this.couponBulkOperationHistoryId = idFromParams || "";
        // 受け取った ID を使って API を呼ぶ
        if (!this.couponBulkOperationHistoryId)
            return;
        await this.callApi(this.couponBulkOperationHistoryId);
        await this.mergeInfo(this.sCResult, this.sUResult);
    },
    methods: {
        openModal() {
            this.show = true;
        },
        closeModal() {
            this.show = false;
        },
        setInfoPage(p) {
            if (p < 1)
                p = 1;
            if (p > this.infoTotalPages)
                p = this.infoTotalPages;
            this.infoPage = p;
        },
        formatDatetime(value) {
            return FormatDate.withoutTzAndMs(value);
        },
        async callApi(id) {
            // クーポン一括操作履歴検索APIを呼び出す
            const sCBRspBody = await searchCouponBulkOperationHistory(id);
            if (sCBRspBody.result?.code === 9) {
                if (sCBRspBody.result?.messages) {
                    this.$store.commit("setMessages", sCBRspBody.result.messages);
                    this.$store.commit("setCancelBtnHide", true);
                    this.$store.commit("setIsModalOpen", true);
                }
                return;
            }
            this.sCBResult = sCBRspBody.data?.results?.[0];
            this.couponCode = this.sCBResult.coupon_code;
            this.name = this.sCBResult.coupon_name;
            // クーポン詳細情報取得APIを呼び出す
            const gCResponse = await getCouponDetail(this.couponCode);
            if (gCResponse.result?.code === 9) {
                if (gCResponse.result?.messages) {
                    this.$store.commit("setMessages", gCResponse.result.messages);
                    this.$store.commit("setCancelBtnHide", true);
                    this.$store.commit("setIsModalOpen", true);
                }
                return;
            }
            else {
                const discount = gCResponse.data.discount;
                const discountUnit = gCResponse.data.discount_unit;
                this.value = discount + (discountUnit === 0 ? "円" : "%");
            }
            // クーポン履歴検索APIを呼び出す
            const sCRspBody = await searchCouponHistory(id, 0);
            if (sCRspBody.result?.code === 9) {
                if (sCRspBody.result?.messages) {
                    this.$store.commit("setMessages", sCRspBody.result.messages);
                    this.$store.commit("setCancelBtnHide", true);
                    this.$store.commit("setIsModalOpen", true);
                }
                return;
            }
            this.sCResult = sCRspBody.data?.results;
            // ユーザ検索APIを呼び出す
            const customerIds = this.sCResult.map((r) => r.crm_customer_id);
            if (customerIds.length) {
                const sURspBody = await searchUser(customerIds, null, null, null, null, null, null);
                if (sURspBody.result?.code === 9) {
                    if (sURspBody.result?.messages) {
                        this.$store.commit("setMessages", sURspBody.result.messages);
                        this.$store.commit("setCancelBtnHide", true);
                        this.$store.commit("setIsModalOpen", true);
                    }
                    return;
                }
                this.sUResult = sURspBody.data?.results;
            }
            else {
                this.sUResult = null;
            }
            return;
        },
        async mergeInfo(CouponHistoryInfoList, UserInfoList) {
            // ユーザを crm_customer_id -> UserInfo の Map に変換
            const userMap = new Map();
            for (const u of UserInfoList) {
                if (u && u.crm_customer_id)
                    userMap.set(u.crm_customer_id, u);
            }
            const merged = CouponHistoryInfoList.map((c) => {
                const user = userMap.get(c.crm_customer_id);
                return {
                    crm_customer_id: c.crm_customer_id || "",
                    user_name: user?.name || "",
                    mobile_phone_number: user?.mobile_phone_number || "",
                    grant_type_detail: c.grant_type || "",
                    history_date: this.formatDatetime(c.history_date),
                };
            });
            // 反映
            this.tableInfo = merged;
            return;
        },
    },
    async mounted() {
        await Authorize.isExpired(this);
    },
};
